import { Injectable } from '@angular/core';
import { AppSettings } from '../../proyect.conf';
import { HttpClient } from '@angular/common/http';
import { AutenticacionService } from './autenticacion.service';
import { map } from 'rxjs/operators';
import {PaqueteSeguros} from '../_models/paquete-seguros';
@Injectable({
  providedIn: 'root'
})
export class PaqueteSegurosService{
  private rutServicio = AppSettings.rutServiciosAPL + '/api/paquetesSeguros';

  constructor( private httClient: HttpClient, private autServicio: AutenticacionService ) {
  }

  listado() {
    return this.httClient.get( this.rutServicio ).pipe( map( res => res as PaqueteSeguros[] ) );
  }

  listadoHabilitados() {
    return this.httClient.get( this.rutServicio + '/enabled' ).pipe( map( res => res as PaqueteSeguros[] ) );
  }

  obtenerPorId( id: string ) {
    return this.httClient.get( this.rutServicio + '/' + id ).pipe( map( res => res as PaqueteSeguros ) );
  }

  crear( regCrear: PaqueteSeguros ) {
    regCrear.auditoriaUsuario = this.autServicio.obtenerIdUsuarioLogueado();
    return this.httClient.post( this.rutServicio, regCrear ).pipe( map( res => res as PaqueteSeguros ) );
  }

  actualizar( regActualizar: PaqueteSeguros ) {
    regActualizar.auditoriaUsuario = this.autServicio.obtenerIdUsuarioLogueado();
    return this.httClient.put( this.rutServicio, regActualizar ).pipe( map( res => res as any ) );
  }

  listadoTradicionalHabilitado() {
    return this.httClient.get( this.rutServicio + '/enabled/indicadorTradicional/true' ).pipe( map( res => res as PaqueteSeguros[] ) );
  }

  listadoDigitalHabilitado() {
    return this.httClient.get( this.rutServicio + '/enabled/indicadorDigital/true' ).pipe( map( res => res as PaqueteSeguros[] ) );
  }


}
